import { FC, ReactElement } from "react";
import datasetsImg from "../img/datasets.png";
import workflowsImg from "../img/models.png";
import predictionImg from "../img/prediction.png";
import realtimeImg from "../img/realtime.png";
import diagnosisImg from "../img/diagnosis.png";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import { useMachine } from "../context/MachineContext";
import { usePrivileges } from "../repositories/hooks/usePrivileges";

interface Props {
  children: ReactElement;
}

export const AppPage: FC<Props> = ({ children }) => {
  const { machineUuid } = useMachine();

  const privileges = usePrivileges();

  const sidebarItems = [
    {
      id: "workflows",
      label: "Workflows",
      icon: workflowsImg,
      link: `/workflows`,
      disabled: !machineUuid,
      hasAccess: privileges.WORKFLOW_R,
    },
    {
      id: "prediction",
      label: "Prediction",
      icon: predictionImg,
      link: `/prediction`,
      disabled: true,
      hasAccess: true,
    },
    {
      id: "realtime",
      label: "Realtime",
      icon: realtimeImg,
      link: `/realtime`,
      disabled: true,
      hasAccess: true,
    },
    {
      id: "diagnosis",
      label: "Diagnosis",
      icon: diagnosisImg,
      link: `/diagnosis`,
      disabled: true,
      hasAccess: true,
      last: true,
    },
    {
      id: "datasets",
      label: "Datasets",
      icon: datasetsImg,
      link: `/datasets`,
      disabled: true,
      hasAccess: true,
    },
  ];

  return (
    <div className="flex">
      <Sidebar items={sidebarItems} />
      <div className="app-content">
        <Header />
        <div>{children}</div>
      </div>
    </div>
  );
};
